import { render, staticRenderFns } from "./SharedList.vue?vue&type=template&id=0edb556c&scoped=true&"
import script from "./SharedList.vue?vue&type=script&lang=ts&"
export * from "./SharedList.vue?vue&type=script&lang=ts&"
import style0 from "./SharedList.vue?vue&type=style&index=0&id=0edb556c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edb556c",
  null
  
)

export default component.exports